<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text>
            <v-layout wrap>
                <v-flex xs12>
                    <template
                        v-if="lead.logs.length"
                    >
                        <v-timeline
                            dense
                            clipped
                            class="calendar-comments"
                        >
                            <v-timeline-item
                                class="mb-4"
                                color="secondary"
                                small
                                v-for="(log, index) in lead.logs"
                                :key="index"
                            >
                                <v-row
                                    justify="space-between"
                                >
                                    <v-col cols="12">
                                        <template v-if="log.status_from_name">{{ log.status_from_name }} -</template>
                                        {{ log.status_to_name }} <br>
                                        <h5>{{ log.user_name }} - {{ log.dateCreated.slice(0, -3) }}</h5>
                                    </v-col>
                                </v-row>
                            </v-timeline-item>
                        </v-timeline>
                    </template>
                    <template
                        v-else
                    >
                        <h3
                            class="text-center mt-3"
                        >
                            No available logs
                        </h3>
                    </template>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                lead: {},

                logs: [],
            }
        },

        props: ['itemInfo'],

        name: 'Lead-Info',

        mounted() {
            this.lead = this.itemInfo;
            setTimeout(() => {
                this.loading = false;
            }, 100);
        },
    }
</script>
